import React, { useEffect, useState } from "react";
import { Carousel, Placeholder } from "react-bootstrap";
import {
  public_advertisement_list,
  public_banner_list,
} from "../../public.api";
import defaultdata from "./components/bannerDummy.json";
import BannerTile from "./components/bannerTile";
import MultiCarousal1 from "./components/multicarousals/multicarousal";

import AdvertisementCarousal from "./components/multicarousals/multicarousal";
import MultiCarousal from "./components/multicarousals/multi.carousal";

export default function Banner(props) {
  const [data, setdata] = useState([]);
  const [advdata, setAdvdata] = useState([]);
  const [url, setUrl] = useState("");
  const [newurl, setNewUrl] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedAd, setSelectedAd] = useState(null);
  const [selectedAdTitle, setSelectedAdTitle] = useState("");
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);

  const [active, setActive] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);
  const handleEventList = () => {
    setActive(true);
    public_banner_list().then((res) => {
      setActive(false);
      setdata(res.data);
      setUrl(res.current_url);
    });
  };
  const handleAdvertisementList = () => {
    public_advertisement_list().then((res) => {
      if (Array.isArray(res)) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const filteredAds = res.filter((ad) => {
          const startDate = new Date(ad.start_date);
          const endDate = new Date(ad.end_date);

          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(0, 0, 0, 0);

          return startDate <= today && endDate >= today;
        });
        setAdvdata(filteredAds);
      } else {
        console.error("Unexpected response format:", res);
      }
    });
  };

  useEffect(() => {
    handleEventList();
    handleAdvertisementList();
  }, []);

  const handlePrevious = () => {
    const count = data.length;
    const lastIndex = count - 1;
    let index = activeIndex - 1;
    if (activeIndex === 0) {
      setActiveIndex(lastIndex);
    } else {
      setActiveIndex(index);
    }
  };
  const handleNext = () => {
    const count = data.length;
    const lastIndex = count - 1;
    let index = activeIndex + 1;
    if (activeIndex === lastIndex) {
      setActiveIndex(0);
    } else {
      setActiveIndex(index);
    }
  };

  return (
    <div className="banner-flex-con">
      {active ? (
        <div className="w-100">
          <Placeholder as={"div"} animation="glow" bg="info">
            <Placeholder xs={12} className="banner-skelton" />
          </Placeholder>
        </div>
      ) : (
        <Carousel className="w-100">
          {
            data &&
              data?.length !== 0 &&
              data?.map((item, index) => (
                <Carousel.Item>
                  <BannerTile
                    key={index}
                    {...props}
                    data={item}
                    baseUrl={url}
                    active={active}
                    advdata={advdata}
                    advUrl={result}
                  />
                </Carousel.Item>
              ))
            // : defaultdata.map((item, index) => (
            //   <Carousel.Item>
            //     <React.Fragment>
            //       <React.Fragment>
            //         <BannerTile {...props} data={item} baseUrl={url} />
            //       </React.Fragment>
            //     </React.Fragment>
            //   </Carousel.Item>
            // ))
          }
        </Carousel>
      )}
      {advdata.length > 0 && (
        <div className="multi-carousel-container">
          <MultiCarousal key={props.active} speed={2000}>
            {advdata.map((item, index) => (
              <div className="d-flex flex-column">
                <img
                  className="par-avatar-ads"
                  key={index}
                  src={`${result}${item.advertisement}`}
                  alt=""
                  onClick={() => {
                    setSelectedAd(`${result}${item.advertisement}`);
                    setShowModal(true);
                    setSelectedAdTitle(item.title || "");
                  }}
                  style={{ cursor: "pointer" }}
                />
                {/* <div
                  className="adv-title"
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item?.title?.length > 10
                    ? `...${item.title.slice(0, 10)}`
                    : item.title}
                </div> */}
              </div>
            ))}
          </MultiCarousal>
        </div>
      )}
      {showModal && (
        <>
          <div className="ad-modal-overlay" onClick={() => setShowModal(false)}>
            <div
              className="ad-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="ad-modal-close"
                onClick={() => setShowModal(false)}
              >
                &times;
              </button>
              <div className="ad-modal-title">{selectedAdTitle}</div>
              <img
                src={selectedAd}
                alt="Selected Advertisement"
                className="ad-modal-image"
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
